module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hall-flex",
    class: 'hall-' + _vm.info.hallId
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12"
  }, [_c('div', {
    staticClass: "hall is-small"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "full-hall"
  }, _vm._l((_vm.rows), function(row) {
    return _c('div', {
      staticClass: "one-row-of-places"
    }, [_c('div', {
      staticClass: "row-number"
    }, [_vm._v(_vm._s(row.row) + " ряд")]), _vm._v(" "), _vm._l((row.places), function(place) {
      return _c('div', {
        staticClass: "place one-place",
        class: {
          active: _vm.isInArray(_vm.places[place]), 'is-loading': _vm.isLoading(_vm.places[place]), disabled: _vm.places[place].sold
        },
        style: ({
          marginLeft: _vm.places[place].margin + 'em'
        }),
        attrs: {
          "data-item": [place]
        },
        on: {
          "click": function($event) {
            _vm.want(_vm.places[place])
          }
        }
      }, [_vm._v("\n                        " + _vm._s(_vm.places[place].place) + "\n                    ")])
    })], 2)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12 has-text-left"
  }, [_c('h2', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "0px"
    },
    on: {
      "click": _vm.openFilm
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.info.name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "font-style": "oblique"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("moment")(_vm.info.datetime, "D MMMM HH:mm")) + " ")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "1px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('p', [_vm._v(" Зал: "), _c('strong', [_vm._v(_vm._s(_vm.info.hall))])]), _vm._v(" "), _c('p', [_vm._v(" Продолжительность: "), _c('strong', [_vm._v(_vm._s(_vm.info.duration) + " мин.")])]), _vm._v(" "), _c('p', [_vm._v(" Возрастные ограничения: "), _c('strong', [_vm._v(_vm._s(_vm.info.ageLimit) + "+")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "0.5rem"
    }
  }, [_vm._v("Выбранные места:")]), _vm._v(" "), (_vm.added.length > 0) ? _c('div', {
    staticClass: "tickets"
  }, [_c('ul', {
    staticStyle: {
      "font-size": "18px"
    }
  }, _vm._l((_vm.added.slice().reverse()), function(ticket) {
    return _c('li', {
      key: ticket.id
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "ticket-alt"
      }
    }), _vm._v("\n                    " + _vm._s(_vm.places[ticket].row) + " ряд - " + _vm._s(_vm.places[ticket].place) + " место\n                    ")], 1)
  })), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "subtitle has-text-right"
  }, [_vm._v("Итого: " + _vm._s(_vm.sum) + " "), _c('font-awesome-icon', {
    attrs: {
      "icon": "ruble-sign"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline tickets__button"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button is-warning",
    class: {
      disabled: _vm.loading.length > 0
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Очистить")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('button', {
    staticClass: "button is-success",
    class: {
      disabled: _vm.loading.length > 0
    },
    on: {
      "click": _vm.buy
    }
  }, [_vm._v("Купить")])]), _vm._v(" "), _c('div', {
    staticClass: "column has-text-centered"
  }, [(!_vm.info.onlyBuy) ? _c('button', {
    staticClass: "button is-info",
    class: {
      disabled: _vm.loading.length > 0
    },
    on: {
      "click": _vm.order
    }
  }, [_vm._v("Забронировать")]) : _vm._e()])])]) : _c('div', {
    staticClass: "notification is-warning"
  }, [_c('strong', [_vm._v("Места не выбраны!")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Легенда")]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-hall"
  }, [_c('div', {
    staticClass: "lifted"
  }, [_c('p', [_vm._v("Экран")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "legend"
  }, [_c('li', [_c('span', {
    staticClass: "place",
    staticStyle: {
      "margin": "0",
      "padding": "4px 12px",
      "height": "28px",
      "width": "31px"
    }
  }), _vm._v(" — Cвободные места.")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "place active",
    staticStyle: {
      "margin": "0",
      "padding": "4px 12px",
      "height": "28px",
      "width": "31px"
    }
  }), _vm._v(" — Выбранные вами.")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "place disabled",
    staticStyle: {
      "margin": "0",
      "padding": "4px 12px",
      "height": "28px",
      "width": "31px"
    }
  }), _vm._v(" — Занятые места.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30a1a8ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue-source/src/app/pages/hall.vue
// module id = 188
// module chunks = 0